export default [
  {
    path: '/pay-equipment',
    name: 'PayDevice',
    component: resolve => require(['@/views/PayDevice'], resolve)
  }
]
